import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import BusinessProfileActionsMenu from './BusinessProfileActionsMenu';
import { Box } from '@mui/material';
import CustomPagination from '../../../components/customPagination';
import { useGetBusinessProfilesHandler } from '../dataHandlers/getBusinessProfilesHandler';
import BusinessProfileTableStatusChip from './BusinessProfilesTableStatusChip';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const BusinessProfilesTable = ({ handlePaginationChange, searchQuery = {} }) => {
  const { businessProfiles, totalDocuments, isLoading } = useGetBusinessProfilesHandler({ searchQuery });
  const { businessProfiles: bp } = useTranslatedMessages();
  const col = bp.table.columns;
  const na = bp.table.not_available;

  const columns = [
    {
      headerName: col.status,
      field: 'status',
      flex: 0.5,
      renderCell: (params) => {
        return <BusinessProfileTableStatusChip status={params.row.status} />;
      },
    },
    {
      field: 'party_name',
      headerName: col.name_company,
      flex: 1,
      renderCell: (params) => {
        return params.row.name ? `${params.row.name} (${params.row.party_name})` : params.row.party_name;
      },
    },
    {
      field: 'contact',
      headerName: col.contact_info,
      flex: 1,
      renderCell: (params) => {
        const contacts = [];
        if (params.row.email) contacts.push(params.row.email);
        if (params.row.telephone) contacts.push(params.row.telephone);
        return contacts.join(' / ') || na;
      },
    },
    {
      field: 'peppol_participant',
      headerName: col.peppol_id,
      flex: 1,
      renderCell: (params) => {
        const { endpoint_id, endpoint_scheme_id } = params.row;
        return endpoint_id && endpoint_scheme_id ? `${endpoint_scheme_id}:${endpoint_id}` : '-';
      },
    },
    {
      field: 'company_id',
      headerName: col.business_identifier,
      flex: 1,
    },
    {
      field: 'address',
      headerName: col.country,
      flex: 1,
      renderCell: (params) => {
        const address = params.row.postal_address;
        if (!address) return na;
        return `${address.country}`;
      },
    },
    {
      field: 'actions',
      headerName: col.actions,
      flex: 0.5,
      sortable: false,
      renderCell: (params) => {
        return <BusinessProfileActionsMenu businessProfile={params.row} />;
      },
    },
  ];

  return (
    <Box>
      <DataGrid
        rows={businessProfiles}
        columns={columns}
        getRowId={(row) => row.id}
        paginationMode="server"
        rowCount={totalDocuments}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 10,
            },
          },
        }}
        pageSizeOptions={[10, 25]}
        disableRowSelectionOnClick
        onPaginationModelChange={(model) => {
          handlePaginationChange(model.page, model.pageSize);
        }}
        slots={{
          pagination: CustomPagination,
        }}
      />
    </Box>
  );
};

export default BusinessProfilesTable;
